import React from "react";

export const Button = (props) => {
  return (
    <div className="div-button">
      <button
        onClick={props.onClick}
        style={props.styles}
        className={props.useZ ? "button" : "button-no-z"}
        disabled={props.disabled}
      >
        {props.children}
      </button>
    </div>
  );
};
